import { Page } from "@/pages/explorer/types";
import { StreamlitNotebookJobRunsListResponse } from "@/pages/query/types";
import { TableHeaderType } from "@/components/tables/types";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { useAppState } from "@/modules/app/useAppContext";
import { formatBytes, formatCost, formatMilliseconds } from "@/helpers/utils";
import dayjs from "dayjs";
import { Stack } from "@altimateai/lego";
import { DataTable } from "@/components/tables";
import { Paginate } from "@/components/paginate";

export const CommonRunsListTable = ({
  basePath,
  tableData,
  page,
  pageSize,
  setPage,
  updatePageSize,
}: {
  basePath: string;
  tableData: Page<StreamlitNotebookJobRunsListResponse>;
  page: number;
  pageSize: number;
  setPage: (page: number) => void;
  updatePageSize: (size: number) => void;
}) => {
  const { hash } = useParams();
  const [searchParams] = useSearchParams();
  const { currency } = useAppState();

  const tableHeaders: TableHeaderType<StreamlitNotebookJobRunsListResponse>[] = [
    {
      id: 1,
      label: "Run ID",
      uid: "run_id",
      width: 350,
      render: (item: StreamlitNotebookJobRunsListResponse) => (
        <Link
          className="al-text-brand condense-text cursor-pointer"
          to={{
            pathname: `/query/${basePath}/${hash!}/${item.session_id}`,
            search: `?run_query=${encodeURIComponent(item.query_summary)}&query_summary=${encodeURIComponent(searchParams.get("query_summary") || "")}`,
          }}
        >
          {item.query_summary}
        </Link>
      ),
    },
    {
      id: 2,
      label: "Run Cost",
      uid: "query_cost",
      render: (item: StreamlitNotebookJobRunsListResponse) => (
        <div>{formatCost(item.query_cost, currency)}</div>
      ),
    },
    {
      id: 3,
      label: "Bytes Scanned",
      uid: "bytes_scanned",
      render: (item: StreamlitNotebookJobRunsListResponse) => (
        <div>{formatBytes(item.bytes_scanned)}</div>
      ),
    },
    {
      id: 4,
      label: "Start Time",
      uid: "start_time",
      render: (item: StreamlitNotebookJobRunsListResponse) => (
        <div>{dayjs(item.start_time).format("YYYY-MM-DD hh:mm a")}</div>
      ),
    },
    {
      id: 5,
      label: "Execution Time",
      uid: "execution_time",
      render: (item: StreamlitNotebookJobRunsListResponse) => (
        <div>{formatMilliseconds(item.execution_time)}</div>
      ),
    },
  ];
  return (
    <Stack direction={"column"} gap={"lg"}>
      <DataTable
        header={tableHeaders}
        data={{
          items: tableData?.items?.slice(page * pageSize, (page + 1) * pageSize),
        }}
        idKey={item => String(item.session_id)}
      />
      <Paginate
        itemCount={tableData?.total || 0}
        numPages={Math.ceil((tableData?.total || 0) / pageSize)}
        page={page}
        pageSize={pageSize}
        onPageClick={setPage}
        onPageSizeChange={updatePageSize}
        showPageSize
      />
    </Stack>
  );
};
